import api from './api';

export interface ExtensionPricingResult {
  rentalId: string;
  currentEndDate: string;
  newEndDate: string;
  weeks: number;
  totalCharge: number;
  lineItems: Array<{
    productSku: string;
    productName: string;
    weeklyRate: number;
    weeks: number;
    lineTotal: number;
  }>;
}

export interface ExtendRentalDto {
  rentalId: string;
  weeks: number;
  billingType?: 'immediate' | 'clinic_invoice';
  notes?: string;
}

export const extensionsApi = {
  calculatePrice: async (rentalId: string, weeks: number): Promise<ExtensionPricingResult> => {
    const { data } = await api.post('/extensions/calculate', { rentalId, weeks });
    return data;
  },

  extend: async (dto: ExtendRentalDto) => {
    const { data } = await api.post('/extensions/extend', dto);
    return data;
  },

  getHistory: async (rentalId: string) => {
    const { data } = await api.get(`/extensions/rental/${rentalId}`);
    return data;
  },
};

export default extensionsApi;
